import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import GenerationSection from './components/generation-section/GenerationSection';
import useGenerateTabs from './hooks/useGenerateTabs';
import { changeGenerateTab } from '../../../redux/activ8/activ8MessagesReducer';
import CommonTabs from '../../../components/common-tabs/CommonTabs';
import CommonTabPanel from '../../../components/common-tabs/CommonTabPanel';
import { ACTIV8_MESSAGE_GENERATE_TABS } from '../../../constants';
import useBindAction from '../../../hooks/useBindAction';
import { saveMessageChanges } from '../../../redux/activ8/activ8MessagesActions';
import UnsavedModalController from './unsaved-modal-controller/UnsavedModalController';
import GeneratedTab from './generated-tab/GeneratedTab';
import SavedTab from './saved-tab/SavedTab';

import scss from './Generate.module.scss';

function Generate() {
  const dispatch = useDispatch();
  const TABS = useGenerateTabs();

  const isDirty = useSelector((state) => state.activ8Messages.isDirty);
  const [isShowUnsavedModal, setIsShowUnsavedModal] = useState(false);
  const { triggerAction, bindAction, resetAction } = useBindAction(isDirty, () => handleShowModal());

  const generateTab = useSelector((state) => state.activ8Messages.generateTab);

  const handleChangeTabs = (_, newTab) => {
    bindAction(() => dispatch(changeGenerateTab(newTab)));
  };

  const handleShowModal = () => {
    setIsShowUnsavedModal(true);
  };

  const handleSaveModal = async () => {
    await dispatch(saveMessageChanges());
  };

  return (
    <>
      <GenerationSection />

      <CommonTabs
        tabs={TABS}
        value={generateTab}
        onChange={handleChangeTabs}
        isFullWidth
        classes={{
          wrapper: scss.wrapper,
        }}
      />

      <CommonTabPanel value={generateTab} index={ACTIV8_MESSAGE_GENERATE_TABS.GENERATED}>
        <GeneratedTab bindNextAction={bindAction} />
      </CommonTabPanel>
      <CommonTabPanel value={generateTab} index={ACTIV8_MESSAGE_GENERATE_TABS.SAVED}>
        <SavedTab bindNextAction={bindAction} />
      </CommonTabPanel>

      <UnsavedModalController
        isShowUnsavedModal={isShowUnsavedModal}
        onChangeUnsavedModalVisibility={setIsShowUnsavedModal}
        resetAction={resetAction}
        triggerAction={triggerAction}
        onSaveChanges={handleSaveModal}
      />
    </>
  );
}

export default Generate;
